module.exports = __webpack_public_path__ + "static/animazione_low-6da041ff9af6eeb3ebbe48d9a19c25ce.mp4";